import React, { Component } from "react";
import { Drawer } from "@material-ui/core";

import Login from "../Login";
import ForgotPassword from "../Login/ForgotPassword";
import SignUp from "../SignUp";

export default class LoginDrawer extends Component {
  render() {
    return (
      <Drawer
        open={this.props.openLoginDrawer}
        onClose={this.props.closeLoginDrawer}
        anchor="right"
      >
        <div className="mbl-drawer" style={{ width: 423, padding: '15px 25px', boxSizing: 'border-box' }}>
          {this.props.showLogin && <Login handleLoginToggle={this.props.handleLoginToggle}
          toggleLoginDrawer={this.props.toggleLoginDrawer} closeLoginDrawer={this.props.closeLoginDrawer}
          handleSignUpToggle={this.props.handleSignUpToggle} /> }
          {this.props.showForgotPassword && <ForgotPassword handleLoginToggle={this.props.handleLoginToggle} toggleLoginDrawer={this.props.toggleLoginDrawer} />}
          {this.props.showSignUp && <SignUp handleSignUpToggle={this.props.handleSignUpToggle} location={this.props.location} closeLoginDrawer={this.props.cancelChannelSignUp} />}
        </div>
      </Drawer>
    );
  }
}
